import { SessionTypeEnum } from "@api/enums/Session/SessionTypeEnum";
import { SelectableTagInterface } from "@api/models/interfaces/SelectableTagInterface";
import { TagsType } from "./filterType"
import i18n from "@service/locale/i18"

export const getSessionTypes = (): SelectableTagInterface[] => {
    return [
        {
            tag: {
                id: SessionTypeEnum.session,
                title: i18n.t('program.session').toString(),
                color: '#19CEAD',
                parentId: TagsType.types
            },
            isSelected: false,
            isVisible: false
        },
        {
            tag: {
                id: SessionTypeEnum.roundtable,
                title: i18n.t('program.roundtable').toString(),
                color: '#C854FF',
                parentId: TagsType.types
            },
            isSelected: false,
            isVisible: false
        },
        {
            tag: {
                id: SessionTypeEnum.speakersQA,
                title: i18n.t('program.speakersQA').toString(),
                color: '#E8B73D',
                parentId: TagsType.types
            },
            isSelected: false,
            isVisible: false
        }
    ]
}

export const getParentTags = () => {
    return [
        {
            id: TagsType.types,
            title: i18n.t('agenda.filter.byType'),
        },
        {
            id: TagsType.tags,
            title: i18n.t('agenda.filter.byTag'),
        }
    ]
}